module.exports = __webpack_public_path__ + "img/root11.9cf87e5d.png";